import React from 'react';
import {Form, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import {convertValueToDollar} from 'common/utils';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {InlineDollarFieldForm as InlineDollarField} from 'app-ui-componentlibrary';
import {safeAdd, safeSubstract} from 'common/utils';

export class BudgetSummaryPanelV2 extends React.Component {
  constructor(props) {
    super(props);
    const appShare = _.get(this.props.budget, 'share.appShare');
    const fedShare = _.get(this.props.budget, 'share.fedShare');
    const total = _.get(this.props.budget, 'budgetSummary.totalCharges');
    this.state = {
      appShare: appShare || [],
      total,
    };
  }

  componentDidUpdate(prevProps) {
    const costShareInformation = _.get(
      this.props.grantsManagement,
      'costShareInformation'
    );
    const budgetShare = _.get(this.props.budget, 'share');
    const waiverDetermination = _.get(costShareInformation, 'waiverDetermination');
    const waiverDeterminationAttachment = _.get(
      this.props,
      'grantsManagement.costShareInformation.waiverDeterminationAttachment'
    );

    const appShareFromBudget = _.get(budgetShare, 'appShare');
    const oldAppShareFromBudget = _.get(prevProps, 'budget.share.appShare');
    const fedShareFromBudget = _.get(budgetShare, 'fedShare');
    const appShareUpdated = _.get(budgetShare, 'appShareUpdated');
    const waivers = _.get(this.props, 'grantsManagement.costShareInformation.waivers');

    const waiverAndCostShare =
      waiverDetermination === 'Approved' && _.get(waivers, 'costShare');

    const becomeEditable = waivers
      ? waiverAndCostShare && !appShareUpdated
      : waiverDetermination === 'Approved' &&
        !_.isEmpty(waiverDeterminationAttachment) &&
        !appShareUpdated;

    const stopBeingEditable = waivers
      ? !waiverAndCostShare && appShareUpdated
      : (waiverDetermination !== 'Approved' ||
          _.isEmpty(waiverDeterminationAttachment)) &&
        appShareUpdated;

    const numIncr = this.state.appShare.length;

    if (becomeEditable) {
      if (_.get(budgetShare, 'originalAppShare') === undefined) {
        this.handleUpdateBudgetShare({
          appShare: _.fill(Array(numIncr), 0),
          originalAppShare: appShareFromBudget,
          appShareUpdated: true,
        });
      } else {
        this.handleUpdateBudgetShare({
          appShare: _.fill(Array(numIncr), 0),
          appShareUpdated: true,
        });
      }
    } else if (stopBeingEditable) {
      this.handleUpdateBudgetShare({
        appShareUpdated: false,
      });
    }
    if (!_.isEqual(oldAppShareFromBudget, appShareFromBudget)) {
      this.setState({
        appShare: appShareFromBudget,
      });
    }
  }

  handleUpdateBudgetShare(newBudgetShare) {
    const {saveEntityData, budget} = this.props;
    saveEntityData(
      'context.awardRecommendation.payload.budget.share',
      'awardRecommendation',
      {
        ..._.get(budget, 'share'),
        ...newBudgetShare,
      }
    );
  }

  renderBudgetSummary({readOnly, index, originalAppShare, appShare}) {
    const errorMessage = `Enter a value less than the original Non-federal resources value of ${convertValueToDollar(
      originalAppShare
    )}`;

    if (readOnly) {
      return convertValueToDollar(appShare);
    } else {
      return (
        <Form.Field>
          <InlineDollarField
            name="appShare"
            value={appShare}
            alignLeft
            handleBlur={() =>
              this.handleUpdateBudgetShare({
                appShare: this.state.appShare,
              })
            }
            handleChange={(name, value) => {
              let appShares = _.cloneDeep(this.state.appShare);
              appShares[index] = value;
              this.setState({appShare: appShares});
            }}
            displayError={appShare > originalAppShare}
            errorMessages={errorMessage}
          />
        </Form.Field>
      );
    }
  }

  render() {
    const matchingFundingStream = _.find(this.props.fundingStreams, (stream) =>
      _.includes(this.props.matchingFundingStreams, stream.fundingStreamType)
    );
    const NUM_INCR = this.state.appShare.length;
    const PERIOD_NAME = this.props.periodType;

    const waiverDetermination = _.get(
      this.props,
      'costShareInformation.waiverDetermination',
      _.get(this.props, 'grantsManagement.costShareInformation.waiverDetermination', '')
    );
    const waiverDeterminationAttachment = _.get(
      this.props,
      'grantsManagement.costShareInformation.waiverDeterminationAttachment'
    );

    const waivers = _.get(this.props, 'grantsManagement.costShareInformation.waivers');
    const readOnly = !(
      waiverDetermination === 'Approved' &&
      (waivers === undefined
        ? !_.isEmpty(waiverDeterminationAttachment)
        : _.get(waivers, 'costShare') === true)
    );

    const originalAppShare = _.get(this.props, 'budget.share.originalAppShare');

    if (!!matchingFundingStream) {
      return (
        <Grid>
          {_.map(Array(NUM_INCR), (val, index) => (
            <Grid.Row>
              <Grid.Column width="6">
                {PERIOD_NAME === 'Year'
                  ? `${PERIOD_NAME} ${index + 1}`
                  : 'Non-federal resources'}
              </Grid.Column>
              <Grid.Column width="10">
                <strong>
                  {this.renderBudgetSummary({
                    readOnly,
                    index,
                    originalAppShare: _.get(originalAppShare, index),
                    appShare: _.get(this.state, `appShare[${index}]`),
                  })}
                </strong>
              </Grid.Column>
            </Grid.Row>
          ))}
        </Grid>
      );
    }
    return null;
  }
}

export default connectDynamic(BudgetSummaryPanelV2);
